import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'libraries/component/loader/loader.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { LoaderModaleComponent } from "libraries/component/loader/loader-modale.component";
import { CardModule } from "libraries/ui_card/card.module";

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule,
        CardModule,
    ],
    declarations: [
        LoaderComponent,
        LoaderModaleComponent,
    ],
    exports: [
        LoaderComponent,
        LoaderModaleComponent,
    ],
})
export class LoaderModule {
}
